const buildRecentListingsImpressionLabel = recentlyViewedListings => {
  const rentalIds = [];
  const saleIds = [];

  recentlyViewedListings.forEach(listing =>
    listing.Typename === "Rental"
      ? rentalIds.push(listing.id)
      : saleIds.push(listing.id)
  );

  const results = [];

  if (rentalIds.length > 0) {
    results.push(`rental=${rentalIds.join(",")}`);
  }
  if (saleIds.length > 0) {
    results.push(`sale=${saleIds.join(",")}`);
  }

  return results.join("|");
};

export default buildRecentListingsImpressionLabel;
